module.exports = __webpack_public_path__ + "img/Inspection3.b03cc970.png";